import { render, staticRenderFns } from "./firmAccount.vue?vue&type=template&id=48d2a461&scoped=true&lang=pug"
import script from "./firmAccount.vue?vue&type=script&lang=js"
export * from "./firmAccount.vue?vue&type=script&lang=js"
import style0 from "./firmAccount.vue?vue&type=style&index=0&id=48d2a461&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48d2a461",
  null
  
)

export default component.exports